var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlackLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 77 13",
    style: {
      enableBackground: "new 0 0 77 13"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#1D1D1B;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    id: "Fill-1_4_",
    className: "st0",
    d: "M4.1,13H3.5C1.4,13,0,11.6,0,9.6V3.3C0,1.4,1.4,0,3.5,0h1c1.1,0,1.8,0.3,2.4,0.8 c0.3,0.3,0.6,0.6,0.8,1C7.7,1.9,7.7,2,7.6,2L6.5,2.6c-0.1,0.1-0.2,0-0.2-0.1C5.9,1.8,5.2,1.4,4.5,1.4h-1c-1.1,0-2,0.9-2,2v6.3 c0,1.1,0.9,2,2,2h0.6c1.1,0,2-0.9,2-2V8.2C6.1,8,6,8,5.9,8H5.4C5.2,8,5.2,7.9,5.2,7.8v-1c0-0.1,0.1-0.2,0.2-0.2h2.1 c0.1,0,0.2,0.1,0.2,0.2v2.8C7.7,11.6,6.3,13,4.1,13"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-4_4_",
    className: "st0",
    d: "M27.5,12.8h-6.6c-0.1,0-0.2-0.1-0.2-0.2V0.4c0-0.1,0.1-0.2,0.2-0.2h6.6c0.1,0,0.2,0.1,0.2,0.2 v1c0,0.1-0.1,0.2-0.2,0.2h-5.1c-0.1,0-0.2,0.1-0.2,0.2v3.7c0,0.1,0.1,0.2,0.2,0.2h4.2c0.1,0,0.2,0.1,0.2,0.2v1 c0,0.1-0.1,0.2-0.2,0.2h-4.2c-0.1,0-0.2,0.1-0.2,0.2v3.9c0,0.1,0.1,0.2,0.2,0.2h5.1c0.1,0,0.2,0.1,0.2,0.2v1 C27.7,12.7,27.7,12.8,27.5,12.8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-6_4_",
    className: "st0",
    d: "M34.1,7v5.6c0,0.1-0.1,0.2-0.2,0.2h-1.2c-0.1,0-0.2-0.1-0.2-0.2V7l-3.4-6.5 c-0.1-0.2,0-0.3,0.2-0.3h1.4c0.1,0,0.1,0.1,0.2,0.1l2.3,4.8c0.1,0.2,0.3,0.2,0.4,0l2.3-4.8c0-0.1,0.1-0.1,0.2-0.1h1.4 c0.2,0,0.3,0.1,0.2,0.3L34.1,7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-8_4_",
    className: "st0",
    d: "M65.9,1.6h-2.4c-0.1,0-0.2,0.1-0.2,0.2v10.8c0,0.1-0.1,0.2-0.2,0.2H62c-0.1,0-0.2-0.1-0.2-0.2 V1.8c0-0.1-0.1-0.2-0.2-0.2h-2.3c-0.1,0-0.2-0.1-0.2-0.2v-1c0-0.1,0.1-0.2,0.2-0.2h6.7c0.1,0,0.2,0.1,0.2,0.2v1 C66.1,1.5,66.1,1.6,65.9,1.6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14_2_",
    className: "st0",
    d: "M53.5,3.8c0.2-0.7,0.3-1.4,0.3-1.4h0.1c0,0,0.1,0.7,0.3,1.4l1.1,4.4c0,0.1,0,0.3-0.2,0.3h-1.7 c0,0-0.2,0-0.2,0.2v1c0,0.2,0.2,0.2,0.2,0.2h2.2c0.1,0,0.2,0,0.2,0.1l0.8,2.7c0,0.1,0.1,0.1,0.2,0.1H58c0.2,0,0.2-0.1,0.2-0.3 L54.5,0.3c0-0.1-0.1-0.1-0.2-0.1h-0.9c-0.1,0-0.2,0-0.2,0.1l-3.7,12.2c0,0.2,0,0.3,0.2,0.3h1.2c0.1,0,0.2,0,0.2-0.1L53.5,3.8z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16_4_",
    className: "st0",
    d: "M76.6,0.2h-1.2c-0.1,0-0.2,0.1-0.2,0.2v5.1c0,0.1-0.1,0.2-0.2,0.2h-3.4c0,0-0.2,0-0.2,0.2v1 c0,0.2,0.2,0.2,0.2,0.2H75c0.1,0,0.2,0.1,0.2,0.2v5.3c0,0.1,0.1,0.2,0.2,0.2h1.2c0.1,0,0.2-0.1,0.2-0.2V0.4 C76.8,0.3,76.7,0.2,76.6,0.2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-19_4_",
    className: "st0",
    d: "M70.4,0.4c0-0.1-0.1-0.2-0.2-0.2H69c-0.1,0-0.2,0.1-0.2,0.2v12.2c0,0.1,0.1,0.2,0.2,0.2h1.2 c0.1,0,0.2-0.1,0.2-0.2V0.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M45,0.2h-3.9c-0.1,0-0.2,0.1-0.2,0.2v12.2c0,0.1,0.1,0.2,0.2,0.2h1.2c0.1,0,0.2-0.1,0.2-0.2V7.5V5V1.8 c0-0.1,0.1-0.2,0.2-0.2H45c1.1,0,2,0.9,2,2v0.2c0,1.1-0.9,1.9-1.9,2c0,0,0,0,0,0h-0.9c0,0-0.2,0-0.2,0.2v1c0,0.2,0.2,0.2,0.2,0.2 h0.9v0h0c2.1,0,3.4-1.5,3.4-3.4C48.5,1.6,47.2,0.2,45,0.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M16.1,6.8c0-0.1,0-0.2,0.1-0.2C17.1,6.2,18,5,18,3.9V3.7c0-2.2-1.4-3.5-3.5-3.5h-3.9c-0.1,0-0.2,0.1-0.2,0.2 v12.2c0,0.1,0.1,0.2,0.2,0.2h1.2c0.1,0,0.2-0.1,0.2-0.2V1.8c0-0.1,0.1-0.2,0.2-0.2h2.4c1.1,0,2,0.9,2,2v0.2c0,1.1-0.9,2-2,2l-1,0 c0,0-0.2,0-0.2,0.2v1c0,0.2,0.2,0.2,0.2,0.2h0.8c0.1,0,0.1,0,0.2,0.1l1.9,5.4c0,0.1,0.1,0.1,0.2,0.1h1.3c0.2,0,0.2-0.1,0.2-0.3 L16.1,6.8z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlackLogo);
export default __webpack_public_path__ + "static/media/black_logo.e790c43f237b1857f18202f5b32eeb87.svg";
export { ForwardRef as ReactComponent };